module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_5_2-65248f2c74faf146c04c500d53b01cc7.svg";